module.exports = __webpack_public_path__ + "./fonts/81e08c44e750e99b663b77197f269f27.woff2";